{
  "action": {
    "administrationRecord": "Print medication signing sheet",
    "wristband": "Print patient wristband",
    "print": "Print",
    "back": "Back to the patient overview",
    "recordExtract": "Print record extract"
  },
  "document": {
    "loading": "Loading the document …",
    "failed": "The document could not be loaded.",
    "notFound": "This patient is not in the record.",
    "retry": "Try again",
    "preview": "Preview. This is what comes out on paper.",
    "confidentialityReview": "Protected identity. Review before printing and before letting the paper out of your hands.",
    "source": "STANDBY RECORD — DOWNTIME MODE",
    "printedAt": "Printed from Continuum {time}.",
    "printedAtUnknown": "The time of printing could not be stated.",
    "verify": "The record may have changed since this was printed. Check against the record."
  },
  "mar": {
    "heading": "Medication signing sheet",
    "identification": "{name} — {identifier}",
    "noIdentifier": "no identifier",
    "safetyHeading": "Safety information",
    "medicationsHeading": "Orders",
    "noMedications": "No current medication orders in the record.",
    "caption": "Current medication orders with boxes for signing, one row per order.",
    "columnSigning": "Given — date, time, signature",
    "signingHint": "Write the date, time and signature for each dose given. The boxes are deliberately blank: the system does not fill in times.",
    "notInRecord": "In downtime mode, doses given are documented on paper and are not written into the record in phase 0.",
    "doseUnprintable": "DOSE CANNOT BE PRINTED",
    "doseWarning": "{count, plural, one {One order has a dose that cannot be printed} other {# orders have doses that cannot be printed}}. Do not sign against an empty dose box — read the dose in the record."
  },
  "wristband": {
    "heading": "Patient wristband",
    "cutHint": "Cut along the dashed line.",
    "born": "Born",
    "barcodeUnavailable": "No barcode can be printed for this identifier. Read the number above.",
    "noIdentifier": "No identifier in the record. A wristband without one cannot be printed — an unidentified patient is given a reservnummer.",
    "checkText": "If the barcode and the digits disagree, the digits are the record."
  },
  "extract": {
    "heading": "Record extract",
    "scope": "This extract shows the patient's current details and every signed note, newest first. Earlier versions of corrected entries are not included — they remain in the record.",
    "admitted": "Admitted",
    "medicationsHeading": "Current medications",
    "medicationsCaption": "Current medication orders, one row per order.",
    "notesHeading": "Signed notes",
    "notesCount": "{count, plural, one {# signed note} other {# signed notes}}",
    "notesCaption": "Signed notes, newest first.",
    "noNotes": "No signed notes in the record.",
    "forensic": "Marked as forensically relevant"
  }
}
